import AspectRatioBox, { AspectRatioBoxRatio } from "@ingka/aspect-ratio-box";
import Image from "@ingka/image";

type PropsType = {
  ratio: AspectRatioBoxRatio;
  src: string;
  srcSet?: string;
  alt: string;
  loading?: string;
};

const AspectRatioImage = (props: PropsType) => {
  return (
    <AspectRatioBox ratio={props.ratio}>
      <Image
        src={props.src}
        alt={props.alt}
        srcSet={props.srcSet}
        loading={props.loading}
      />
    </AspectRatioBox>
  );
};

export default AspectRatioImage;
